import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import './Payment.css'; // Подключаем стили

import main from '../assets/img/pay_page.png';

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { from } = location.state || { from: { pathname: '/' } };

  const [email, setEmail] = useState(''); // Состояние для email
  const [isAgreedToTerms, setIsAgreedToTerms] = useState(false); // Согласие с условиями
  const [isAgreedToAutoPay, setIsAgreedToAutoPay] = useState(false); // Согласие с автоплатежами
  const [showCardForm, setShowCardForm] = useState(false); // Показывать ли форму оплаты картой
  const [cardNumber, setCardNumber] = useState(''); // Номер карты
  const [expiryDate, setExpiryDate] = useState(''); // Срок действия
  const [cvv, setCvv] = useState(''); // CVV
  const [showCvv, setShowCvv] = useState(false); // Показывать ли CVV
  const [showBankList, setShowBankList] = useState(false); // Показывать ли список банков
  const [isClosing, setIsClosing] = useState(false); // Состояние для анимации закрытия
  const [selectedBank, setSelectedBank] = useState(null); // Выбранный банк
  const [searchQuery, setSearchQuery] = useState(''); // Поисковый запрос

  const banks = [
    'Сбербанк',
    'Тинькофф',
    'Альфа-Банк',
    'ВТБ',
    'Газпромбанк',
    'Название Банка',
    'Название Банка',
    'Название Банка',
    'Название Банка',
    'Название Банка',
    'Название Банка',
    'Название Банка',
    'Название Банка'
  ]; // Список банков

  // Фильтрация банков по поисковому запросу
  const filteredBanks = banks.filter(bank => bank.toLowerCase().includes(searchQuery.toLowerCase()));

  // Проверка корректности email
  const isValidEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Простое регулярное выражение для email
    return emailRegex.test(email);
  };

  // Проверка, можно ли активировать кнопку "Оплатить"
  const isPaymentDisabled = !isValidEmail(email) || !isAgreedToTerms || !isAgreedToAutoPay;

  const handlePaymentSuccess = () => {
    if (isPaymentDisabled) {
      alert('Пожалуйста, заполните все поля и подтвердите согласие.');
      return;
    }
    // Обработка успешной оплаты
    navigate(from); // Вернуть пользователя на предыдущую страницу
  };

  const handleCardPayment = () => {
    if (!cardNumber || !expiryDate || !cvv) {
      alert('Пожалуйста, заполните все поля карты.');
      return;
    }

    // Валидация срока действия карты
    const [month, year] = expiryDate.split('/');
    const currentYear = new Date().getFullYear() % 100; // Текущий год (две последние цифры)
    const currentMonth = new Date().getMonth() + 1; // Текущий месяц (1–12)

    if (
      !month ||
      !year ||
      isNaN(month) ||
      isNaN(year) ||
      month < 1 ||
      month > 12 ||
      year < 25 ||
      year > 99 ||
      (year == currentYear && month < currentMonth)
    ) {
      alert('Некорректный срок действия карты. Убедитесь, что месяц от 01 до 12, а год от 25 до 99.');
      return;
    }

    // Обработка оплаты картой
    alert('Оплата прошла успешно!');
    navigate(from); // Вернуть пользователя на предыдущую страницу
  };

  // Обработчик изменения срока действия карты
  const handleExpiryDateChange = e => {
    let value = e.target.value.replace(/\D/g, ''); // Удаляем все нецифровые символы
    if (value.length > 2) {
      value = value.slice(0, 2) + '/' + value.slice(2, 4); // Добавляем "/" после MM
    }
    setExpiryDate(value);
  };

  // Обработчик изменения номера карты
  const handleCardNumberChange = e => {
    let value = e.target.value.replace(/\D/g, ''); // Удаляем все нецифровые символы
    if (value.length > 16) {
      value = value.slice(0, 16); // Ограничиваем длину номера карты 16 цифрами
    }
    // Разделяем номер карты на группы по 4 цифры
    value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
    setCardNumber(value);
  };

  // Обработчик выбора банка
  const handleBankSelection = bank => {
    setSelectedBank(bank); // Устанавливаем выбранный банк
  };

  // Закрытие списка банков с анимацией
  const closeBankList = () => {
    setIsClosing(true); // Запускаем анимацию закрытия
    setTimeout(() => {
      setShowBankList(false); // Скрываем список банков после завершения анимации
      setIsClosing(false); // Сбрасываем состояние анимации
      setSelectedBank(null); // Сбрасываем выбранный банк
    }, 300); // Время анимации (300 мс)
  };

  useEffect(() => {
    const header = document.querySelector('header'); // Замените на ваш селектор хедера
    const footer = document.querySelector('footer'); // Замените на ваш селектор футера

    if (showCardForm) {
      // Скрываем хедер и футер
      if (header) header.style.display = 'none';
      if (footer) footer.style.display = 'none';
    } else {
      // Показываем хедер и футер
      if (header) header.style.display = 'block';
      if (footer) footer.style.display = 'block';
    }

    // Очистка эффекта при размонтировании компонента
    return () => {
      if (header) header.style.display = 'block';
      if (footer) footer.style.display = 'block';
    };
  }, [showCardForm]);

  const handleCardPaymentClick = () => {
    setShowCardForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // При возврате назад также нужно обработать показ хедера и футера
  const handleBackClick = () => {
    setShowCardForm(false);
  };

  return (
    <div className="payment-page">
      <div className="payment-container">
        {/* Если форма оплаты картой не показана, отображаем основной интерфейс */}
        {!showCardForm ? (
          <>
            {/* Картинка */}
            <img src={main} alt="Оформление заказа" className="payment-image" />
            <div className="payment-block">
              {/* Заголовок и цена */}
              <h1 className="payment-title">Оформление заказа</h1>
              <div className="payment-price">
                <span className="discounted-price">29₽</span>
                <span className="original-price">999₽</span>
                <span className="discount">-70%</span>
              </div>

              {/* Поле для ввода email */}
              <div className="payment-email">
                <label htmlFor="email">Введите ваш Email:</label>
                <input
                  type="email"
                  id="email"
                  placeholder="example@gmail.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
                {email && !isValidEmail(email) && <p className="error-message"></p>}
              </div>

              {/* Условия и соглашения */}
              <div className="payment-terms">
                <div className="terms-block">
                  <input
                    type="checkbox"
                    id="terms"
                    checked={isAgreedToTerms}
                    onChange={e => setIsAgreedToTerms(e.target.checked)}
                  />
                  <label htmlFor="terms">
                    Нажимая кнопку “Оплатить” Вы даете согласие на обработку персональных данных, а также подтверждаете
                    ознакомление с{' '}
                    <a href="/public-offer" target="_blank" rel="noopener noreferrer">
                      публичной офертой
                    </a>{' '}
                    и{' '}
                    <a href="/tariffs" target="_blank" rel="noopener noreferrer">
                      тарифами
                    </a>
                    .
                  </label>
                </div>

                <div className="terms-block">
                  <input
                    type="checkbox"
                    id="auto-pay"
                    checked={isAgreedToAutoPay}
                    onChange={e => setIsAgreedToAutoPay(e.target.checked)}
                  />
                  <label htmlFor="auto-pay">
                    Нажимая кнопку “Оплатить” Вы подтверждаете ознакомление с автоматическими списаниями. Для клиентов,
                    оплативших картой банка СберБанк установлен следующий тариф: через 7 дней доступ автоматически
                    продлевается на 7 суток за 200₽. Для клиентов другого банка: через 7 дней доступ продлевается на 28
                    суток за 2079₽ или 297₽ за 4 дня в случае недостаточности средств.
                  </label>
                </div>
              </div>

              {/* Кнопки оплаты */}
              <div className="payment-buttons">
                <button
                  className="payment-button sber"
                  onClick={() => setShowBankList(true)}
                  disabled={isPaymentDisabled} // Кнопка неактивна, если условия не выполнены
                >
                  Оплатить по СПБ
                </button>
                <button
                  className="payment-button card"
                  onClick={handleCardPaymentClick} // Используем новый обработчик
                  disabled={isPaymentDisabled}
                >
                  Оплатить банковской картой
                </button>
              </div>
            </div>
            {/* Список банков (появляется снизу) */}
            {showBankList && (
              <div className={`bank-list-container ${isClosing ? 'slide-down' : 'slide-up'}`}>
                <div className="bank-list">
                  <button className="close-button" onClick={closeBankList}></button>
                  <h3>Выберите банк</h3>

                  {/* Поле поиска */}
                  <div className="search-container">
                    <input
                      type="text"
                      placeholder="Поиск банка..."
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                    />
                  </div>

                  {/* Список банков */}
                  <ul>
                    {filteredBanks.map((bank, index) => (
                      <li key={index} onClick={() => handleBankSelection(bank)}>
                        <label htmlFor={`bank-${index}`}>
                          <input
                            type="radio"
                            id={`bank-${index}`}
                            name="bank"
                            value={bank}
                            checked={selectedBank === bank}
                            onChange={() => handleBankSelection(bank)}
                          />
                          {bank}
                        </label>
                      </li>
                    ))}
                  </ul>

                  {/* Кнопка "Оплатить" после выбора банка */}
                  {selectedBank && (
                    <button
                      className="payment-button pay-now spb-pay"
                      onClick={handlePaymentSuccess}
                      disabled={isPaymentDisabled} // Кнопка неактивна, если условия не выполнены
                    >
                      Оплатить
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        ) : (
          // Если форма оплаты картой показана
          <>
            {/* Заголовок и кнопка назад */}
            <div className="card-form-header">
              <h1 className="payment-title">Оплата</h1>
              <button className="back-button" onClick={() => setShowCardForm(false)}>
                Назад
              </button>
            </div>

            {/* Плашка в виде карты */}
            <div className="card-form">
              <div className="card-input">
                <label htmlFor="card-number">Номер карты</label>
                <input
                  type="text"
                  id="card-number"
                  placeholder="0000 0000 0000 0000"
                  value={cardNumber}
                  onChange={handleCardNumberChange}
                  maxLength={19} // 16 цифр + 3 пробела
                />
              </div>

              <div className="card-input">
                <label htmlFor="expiry-date">MM/YY</label>
                <input
                  type="text"
                  id="expiry-date"
                  placeholder="MM/YY"
                  value={expiryDate}
                  onChange={handleExpiryDateChange}
                  maxLength={5}
                />
              </div>

              <div className="card-input">
                <label htmlFor="cvv">CVV</label>
                <div className="cvv-input">
                  <input
                    type={showCvv ? 'text' : 'password'}
                    id="cvv"
                    placeholder="***"
                    maxLength={3}
                    value={cvv}
                    onChange={e => setCvv(e.target.value)}
                  />
                  <button className="show-cvv" onClick={() => setShowCvv(!showCvv)}>
                    {showCvv ? '🙈' : '👁️'}
                  </button>
                </div>
              </div>

              {/* Итого */}
              <div className="total-amount">
                <span>Итого:</span>
                <span className="amount">29₽</span>
              </div>

              {/* Кнопка оплатить */}
              <button
                className="payment-button pay-now"
                onClick={handleCardPayment}
                disabled={!cardNumber || !expiryDate || !cvv} // Кнопка неактивна, если поля карты не заполнены
              >
                Оплатить
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentPage;
